module.exports = __webpack_public_path__ + "img/Nav_edit.c39ea8f3.svg";